/* COUNTRY HIGH — Mobile-Rails (Swipe-Karussells + Punkte/Pfeile/Zähler) + Sticky-CTA. 1:1 nach Claude Design. */
(function () {
  var chwireonce = !window.__chRailListeners;
  var DOT_ON = 'flex:none;width:22px;height:7px;border-radius:999px;border:none;padding:0;cursor:pointer;transition:width 220ms cubic-bezier(0.22,0.61,0.36,1),background 220ms ease;background:var(--ch-ink)';
  var DOT_OFF = 'flex:none;width:7px;height:7px;border-radius:999px;border:none;padding:0;cursor:pointer;transition:width 220ms cubic-bezier(0.22,0.61,0.36,1),background 220ms ease;background:rgba(26,26,26,0.22)';
  function arrowStyle(dim) {
    return 'flex:none;width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:transparent;border:1.5px solid ' +
      (dim ? 'rgba(26,26,26,0.15)' : 'rgba(26,26,26,0.45)') + ';color:' + (dim ? 'rgba(26,26,26,0.25)' : 'var(--ch-ink)') +
      ';cursor:' + (dim ? 'default' : 'pointer') + ';transition:border-color 180ms ease,color 180ms ease';
  }
  function rail(name) { return document.querySelector('[data-rail="' + name + '"]'); }
  function activeIndex(el) {
    var center = el.scrollLeft + el.clientWidth / 2, best = 0, bd = Infinity;
    Array.prototype.slice.call(el.children).forEach(function (k, i) {
      var d = Math.abs(k.offsetLeft + k.offsetWidth / 2 - center);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  function set(el, attr, want) {
    if (!el) return;
    if (attr === 'text') { if (el.textContent !== want) el.textContent = want; return; }
    if (el.getAttribute(attr) !== want) el.setAttribute(attr, want);
  }
  function paint(name, i, total) {
    document.querySelectorAll('[data-rail-dot="' + name + '"]').forEach(function (d) {
      set(d, 'style', Number(d.getAttribute('data-index')) === i ? DOT_ON : DOT_OFF);
    });
    set(document.querySelector('[data-rail-prev="' + name + '"]'), 'style', arrowStyle(i === 0));
    set(document.querySelector('[data-rail-next="' + name + '"]'), 'style', arrowStyle(i === total - 1));
    var count = document.querySelector('[data-rail-count="' + name + '"]');
    if (count) {
      var pre = count.getAttribute('data-prefix');
      var T = window.CH_T || {}; var pm = { 'Foto': T.photo, 'Event': T.event, 'Stimme': T.voice }; if (pre && pm[pre]) pre = pm[pre];
      set(count, 'text', (pre ? pre + ' ' : '') + (i + 1) + ' ' + (T.of || 'von') + ' ' + total);
    }
  }
  function sync(name) {
    var el = rail(name); if (!el) return;
    paint(name, activeIndex(el), el.children.length);
  }
  function goTo(name, i) {
    var el = rail(name); if (!el) return;
    var idx = Math.max(0, Math.min(el.children.length - 1, i));
    var kid = el.children[idx];
    if (!kid) return;
    el.scrollLeft = kid.offsetLeft - (el.clientWidth - kid.offsetWidth) / 2;
    paint(name, idx, el.children.length);
  }
  if (chwireonce) document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-rail-dot],[data-rail-prev],[data-rail-next]');
    if (!t) return;
    ev.preventDefault();
    if (t.hasAttribute('data-rail-dot')) return goTo(t.getAttribute('data-rail-dot'), Number(t.getAttribute('data-index')));
    var name = t.getAttribute('data-rail-prev') || t.getAttribute('data-rail-next');
    var el = rail(name); if (!el) return;
    goTo(name, activeIndex(el) + (t.hasAttribute('data-rail-prev') ? -1 : 1));
  });
  var frame = null;
  if (chwireonce) document.addEventListener('scroll', function (ev) {
    var el = ev.target;
    if (!el || !el.getAttribute || !el.hasAttribute('data-rail')) return;
    var name = el.getAttribute('data-rail');
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () { frame = null; sync(name); });
  }, true);
  function syncAll() {
    document.querySelectorAll('[data-rail]').forEach(function (el) { sync(el.getAttribute('data-rail')); });
  }
  function wireSticky() {
    document.querySelectorAll('[data-ch-sticky]').forEach(function (bar) {
      var name = bar.getAttribute('data-ch-sticky');
      var sentinel = name ? document.querySelector('[data-ch-sticky-sentinel="' + name + '"]') : null;
      var past = sentinel ? sentinel.getBoundingClientRect().top < 0
                          : window.scrollY > window.innerHeight * 0.6;
      var want = past ? 'translateY(0)' : 'translateY(110%)';
      if (bar.style.transform !== want) bar.style.transform = want;
    });
  }
  if (chwireonce) {
    window.addEventListener('scroll', wireSticky, { passive: true });
    window.addEventListener('resize', function () { syncAll(); wireSticky(); }, { passive: true });
  }
  window.__chRailListeners = true;
  var kick = function () {
    syncAll(); wireSticky();
    setTimeout(function () { syncAll(); wireSticky(); }, 500);
    setTimeout(function () { syncAll(); wireSticky(); }, 2000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick); else kick();
})();
